// claude の指摘: メモリリーク対策として、イベントリスナーをクリーンアップ
document.addEventListener("turbo:load", () => {
  const navbarCollapse = document.getElementById('global-navbar');
  const searchFormCollapse = document.getElementById('mobile-search-form');
  let isNavbarOpen = false;
  let isSearchFormOpen = false;
  function updateBackdrop() {
    const isAnyOpen = isNavbarOpen || isSearchFormOpen;
    document.body.classList.toggle('navbar-backdrop-active', isAnyOpen);
  }
  const handlers = [];
  if (navbarCollapse) {
    const showHandler = () => { isNavbarOpen = true; updateBackdrop(); };
    const hideHandler = () => { isNavbarOpen = false; updateBackdrop(); };

    navbarCollapse.addEventListener('show.bs.collapse', showHandler);
    navbarCollapse.addEventListener('hide.bs.collapse', hideHandler);

    handlers.push({ el: navbarCollapse, event: 'show.bs.collapse', handler: showHandler });
    handlers.push({ el: navbarCollapse, event: 'hide.bs.collapse', handler: hideHandler });
  }
  if (searchFormCollapse) {
    const showHandler = () => { isSearchFormOpen = true; updateBackdrop(); };
    const hideHandler = () => { isSearchFormOpen = false; updateBackdrop(); };

    searchFormCollapse.addEventListener('show.bs.collapse', showHandler);
    searchFormCollapse.addEventListener('hide.bs.collapse', hideHandler);

    handlers.push({ el: searchFormCollapse, event: 'show.bs.collapse', handler: showHandler });
    handlers.push({ el: searchFormCollapse, event: 'hide.bs.collapse', handler: hideHandler });
  }
  // ページ遷移時にクリーンアップ
  document.addEventListener('turbo:before-render', () => {
    handlers.forEach(({ el, event, handler }) => {
      el.removeEventListener(event, handler);
    });
  }, { once: true });
});